module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ded",
    attrs: {
      "id": "start"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("For my children, Victoria and Gabriella,"), _c('br'), _vm._v("whose patience with their busy mother"), _c('br'), _vm._v("and curiosity about this project never abated,"), _c('br'), _vm._v("I happily dedicate this book to them both."), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0270226","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/dedication.vue
// module id = 72
// module chunks = 0